import React, { useState, useEffect } from 'react';
import {
  Box,
  HStack,
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  useDisclosure,
  Spinner,
  Input,
  Flex,
  Button,
  Heading,
  Icon,
  ModalFooter,
  Tag,
  VStack,
  Badge,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  Modal,
  useToast,
  Center,
  Tooltip,
  ButtonGroup
} from '@chakra-ui/react';

import { fetchWrapper } from '../../helpers';
import { useCsvExport } from '../../context/CsvExportContext';
import moment from 'moment';
import Header from '../../components/Header';
import { ExternalLinkIcon, RepeatIcon, TimeIcon, WarningIcon, ChevronDownIcon, CheckIcon, ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import 'moment-timezone';
import Select from "react-select";
import { MdOutlineFilterAlt, MdOutlineFilterAltOff } from 'react-icons/md';
import { FaMobileAlt } from 'react-icons/fa';
import { LuInfo, LuScrollText } from 'react-icons/lu';
import PageHeading from '../../components/shared/PageHeading';
import { FiCheckCircle } from "react-icons/fi";
import { FiXCircle } from "react-icons/fi";
import RecipientInfo from '../../components/shared/RecipientInfo';
import { getUserTimeZone } from '../../utils/DefaultFunction';
import usePagePermissions from '../../hooks/usePagePermissions';
import { Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";

import Prism from 'prismjs';
import API from '../../helpers/axiosInstance';
import { useLocation } from 'react-router-dom';
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper';
import EmailPreviewModal from '../TemplateManager/CreateTemplate/EmailPreviewModal';
import { decodeHtmlEntities } from '../TemplateManager/CreateTemplate/EmailDesigner/htmlExport';
import { CHANNEL, getChannel, getChannelLabel } from '../../utils/channels';

function MessageLogs({ header }) {
  const location = useLocation();
  const toast = useToast();
  const {
    isOpen: isPayloadOpen,
    onOpen: onPayloadOpen,
    onClose: onPayloadClose,
  } = useDisclosure();

  const {
    isOpen: isErrorLogOpen,
    onOpen: onErrorLogOpen,
    onClose: onErrorLogClose,
  } = useDisclosure();

  const user = JSON.parse(localStorage.getItem('customer'));
  const customer_id = JSON.parse(localStorage.getItem("customer"))?.customer_id;

  const { loading: permissionsLoading, can } = usePagePermissions('message-logs');
  const listPermission = can('dr-list');
  const exportPermission = can('dr-export');
  const viewPaylaodPermission = can('dr-view-payload');

  // Main data states
  const [statusList, setStatusList] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  // Cursor pagination: /msg-log/list returns opaque next/prev cursors instead
  // of a total count, so there are no page numbers to jump to — only
  // Previous/Next.
  const FIRST_PAGE = { cursor: null, direction: 'next' };
  const [pageRequest, setPageRequest] = useState(FIRST_PAGE);
  const [paging, setPaging] = useState({ next_cursor: null, prev_cursor: null, has_next: false, has_prev: false });
  const [stats, setStats] = useState({
    count: 0,
    delivered_read: 0,
    msgFail: 0,
    msgSentCount: 0,
    success_rate: 0,
  });
  const [isOpen, setIsOpen] = useState(false);

  // Filter data states
  const [channelData, setChannelData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [channelOptions, setchannelOptions] = useState([]);
  const [statusOptions, setstatusOptions] = useState([]);

  // Filter states
  const [showFilters, setShowFilters] = useState(false);

  // Applied filter states (sent to API)
  const [appliedChannel, setAppliedChannel] = useState(null);
  const [appliedStatus, setAppliedStatus] = useState(null);
  const [appliedStartDate, setAppliedStartDate] = useState('');
  const [appliedEndDate, setAppliedEndDate] = useState('');

  // Temporary filter states (for UI only, until Apply is clicked)
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [debouncedSearchValue, setDebouncedSearchValue] = useState('');

  const [selectedMessage, setSelectedMessage] = useState("");
  // { to, body, templateId, fromTemplate } while an HTML body is open in the preview
  // modal; null when closed.
  const [htmlPreview, setHtmlPreview] = useState(null);
  const [templatePreviewLoading, setTemplatePreviewLoading] = useState(false);
  const [autoRefreshInterval, setAutoRefreshInterval] = useState(0);
  const [selectedPayload, setSelectedPayload] = useState(null);
  const [selectedErrorLog, setSelectedErrorLog] = useState(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const { startExport, isExporting } = useCsvExport();

  const getApiHeaders = () => ({
    "x-api-key": localStorage.getItem('api-key'),
    "x-access-token": localStorage.getItem('customer-portal'),
  });

  const loadList = async () => {
    setLoading(true)

    try {
      const params = new URLSearchParams();

      // `cursor` always goes out — empty on the first page, then the API's next/prev cursor.
      params.append("cursor", pageRequest.cursor || "");
      // "next" on first load; "next"/"prev" from whichever button was pressed.
      params.append("direction", pageRequest.direction || "next");

      if (appliedChannel?.value) params.append("channel", appliedChannel.value);
      if (appliedStatus?.value) params.append("status", appliedStatus.value);
      if (appliedStartDate) params.append("start_date", moment(appliedStartDate).format("YYYY-MM-DD"));
      if (appliedEndDate) params.append("end_date", moment(appliedEndDate).format("YYYY-MM-DD"));
      if (debouncedSearchValue.trim()) params.append("search", debouncedSearchValue.trim());

      const url = `${process.env.REACT_APP_API_URL}/msg-log/list?${params.toString()}&pageSize=50&tz=${getUserTimeZone()}`;
      const data = await fetchWrapper.get(url);

      const {
        count = 0,
        delivered_read = 0,
        msgFail = 0,
        msgSentCount = 0,
        success_rate = 0,
      } = data || {};

      setStats({ count, delivered_read, msgFail, msgSentCount, success_rate });
      setList(data.data || []);
      setPaging({
        next_cursor: data?.paging?.next_cursor || null,
        prev_cursor: data?.paging?.prev_cursor || null,
        has_next: Boolean(data?.paging?.has_next),
        has_prev: Boolean(data?.paging?.has_prev),
      });
      setLoading(false)
    } catch (error) {
      console.error("Error loading message logs:", error);
      setList([]);
      setPaging({ next_cursor: null, prev_cursor: null, has_next: false, has_prev: false });
      setLoading(false)
    } finally {
      setLoading(false)
    }
  };

  const loadChannelList = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/channel/list`;
      const data = await fetchWrapper.get(url);
      setChannelData(data.data || []);
      setchannelOptions(data.data.map((item) => ({
        label: getChannel(item?.id)?.label || getChannelLabel(item?.name),
        value: item?.id
      })));
    } catch (error) {
      console.error('Error loading channels:', error);
    }
  };

  const loadStatusList = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/status/list`;
      const data = await fetchWrapper.get(url);
      setStatusData(data.data || []);
      setstatusOptions(data.data.map((item) => ({
        label: item?.name,
        value: item?.id
      })));
    } catch (error) {
      console.error('Error loading status list:', error);
    }
  };

  const getStatusList = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/status/list`;
      const res = await fetchWrapper.get(url);
      setStatusList(res?.data || res || []);
    } catch (err) {
      console.error("Failed to load status list:", err);
    }
  };

  // SINGLE INITIALIZATION - Runs ONCE on mount
  useEffect(() => {
    if (isInitialized) return;

    const initializeApp = async () => {
      // setLoading(true);

      try {
        // Fetch all reference data in parallel
        await Promise.all([
          loadChannelList(),
          loadStatusList(),
          getStatusList(),
        ]);

        // // Fetch initial list data
        // await loadList();

        setIsInitialized(true);
      } catch (error) {
        console.error("Initialization error:", error);
      } finally {
        // setLoading(false);
      }
    };

    initializeApp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Debounced search effect - only after initialization
  useEffect(() => {
    if (!isInitialized) return;

    const timer = setTimeout(() => {
      // A cursor belongs to the old result set — restart from page 1 on a new search.
      if (searchValue !== debouncedSearchValue) setPageRequest(FIRST_PAGE);
      setDebouncedSearchValue(searchValue);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchValue, isInitialized]);

  // Load data when filters change - only after initialization, and only once
  // permissions have resolved and the list permission is actually granted.
  useEffect(() => {
    if (!isInitialized) return;
    if (permissionsLoading || !listPermission) return;

    loadList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    appliedChannel,
    appliedStatus,
    appliedStartDate,
    appliedEndDate,
    debouncedSearchValue,
    pageRequest,
    isInitialized,
    permissionsLoading,
    listPermission
  ]);

  // Auto-refresh interval - only after initialization
  useEffect(() => {
    if (!isInitialized || !autoRefreshInterval) return;

    const interval = setInterval(() => {
      loadList();
    }, autoRefreshInterval);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    autoRefreshInterval,
    appliedChannel,
    appliedStatus,
    appliedStartDate,
    appliedEndDate,
    debouncedSearchValue,
    pageRequest,
    isInitialized
  ]);

  const applyFilters = () => {
    setAppliedChannel(selectedChannel);
    setAppliedStatus(selectedStatus);
    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
    setPageRequest(FIRST_PAGE);
    setShowFilters(false);
  };

  const clearFilters = () => {
    setSelectedChannel(null);
    setSelectedStatus(null);
    setStartDate('');
    setEndDate('');
    setAppliedChannel(null);
    setAppliedStatus(null);
    setAppliedStartDate('');
    setAppliedEndDate('');
    setSearchValue('');
    setPageRequest(FIRST_PAGE);
  };

  const scrollToTop = () => {
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch { /* old browsers */ }
  };

  const goToNextPage = () => {
    if (!paging.has_next || !paging.next_cursor) return;
    setPageRequest({ cursor: paging.next_cursor, direction: 'next' });
    scrollToTop();
  };

  const goToPrevPage = () => {
    if (!paging.has_prev || !paging.prev_cursor) return;
    setPageRequest({ cursor: paging.prev_cursor, direction: 'prev' });
    scrollToTop();
  };

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const getChannelInfo = (channelIdOrName) => {
    return (
      getChannel(channelIdOrName) || { label: "System", icon: FaMobileAlt, color: "gray" }
    );
  };

  const openModal = (msg) => {

    setSelectedMessage(msg);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedMessage(null);
  };

  const getStatusDetails = (statusId) => {
    return statusList.find((s) => s.status_id === statusId || s.id === statusId);
  };

  // status_id 110 isn't in the /status/list response, so getStatusDetails finds
  // nothing for it — the journey used to fall back to the bare "Status 110" with a
  // failure (✗) icon, since a missing msg_status reads as not-success.
  const KNOWN_STATUS_FALLBACKS = { 110: { name: 'Sent to device', msg_status: '1' } };

  const getStatusColor = (statusName) => {
    const name = statusName?.toLowerCase() || "";
    if (name.includes("read") || name.includes("delivered")) return "green";
    if (name.includes("sent")) return "blue";
    if (name.includes("fail") || name.includes("undeliverable")) return "red";
    if (name.includes("accept")) return "green";
    return "gray";
  };

  /**
   * The status pills below colour themselves from `Status.color` straight off the
   * API — but a name like "black" (seen on "Opt Out" / "Country Not Allowed") isn't
   * one of Chakra's color scales, so `black.200` etc. resolve to nothing: no
   * background, and a border that falls back to the browser's default (solid
   * black), which is exactly the plain outlined look those statuses had. Only pass
   * through colors Chakra can actually shade.
   */
  const CHAKRA_COLOR_SCALES = new Set([
    "gray", "red", "orange", "yellow", "green", "teal", "blue", "cyan", "purple", "pink",
  ]);
  const safeStatusColor = (color) => {
    const normalized = String(color || "").toLowerCase();
    return CHAKRA_COLOR_SCALES.has(normalized) ? normalized : "gray";
  };

  const regexCheckHtml = /<[^>]*>/;

  /**
   * Rendered body of a delivery-log row.
   *
   * The table read `item.message` only, so any row whose record carries the body under
   * `message_content` — the field the campaign message-details endpoint returns —
   * displayed as "—" purely because of the field name. Reads whichever is populated.
   *
   * NOTE: if BOTH are empty the row genuinely has no stored content and the backend has
   * to populate it; nothing the table can do will conjure it.
   */
  const messageBodyOf = (row) => row?.message || row?.message_content || '';

  /**
   * Fallback preview for a recorded body that cannot render.
   *
   * The log pipeline masks every digit in `message` to `****`, which destroys the HTML
   * beyond repair — `<h1>` becomes `<h****>`, `padding:16px` becomes `padding:****px`,
   * `border="0"` becomes `border="****"`, and every image URL containing a digit 404s.
   * `message_template_id` survives unmasked, so the source template can be fetched and
   * rendered to show what the email actually looks like.
   *
   * This is explicitly NOT what the recipient received — variables are unsubstituted and
   * a later template edit would show through — hence the note carried into the modal.
   */
  const loadTemplatePreview = async (templateId) => {
    if (!templateId) return;
    setTemplatePreviewLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_URL}/template-message/get-by-id?id=${templateId}`;
      const res = await API.get(url, { headers: getApiHeaders() });
      const tpl = res?.data?.data || res?.data || {};
      let combine = {};
      try {
        combine = tpl.message_combine ? JSON.parse(tpl.message_combine) : {};
      } catch (e) {
        console.error('Failed to parse message_combine for template', templateId, e);
      }
      const html = decodeHtmlEntities(combine.emailHtml || combine.html_code || tpl.html_code || '');
      if (!html.trim()) {
        toast({ title: 'No email HTML stored on this template', status: 'warning', duration: 4000, isClosable: true });
        return;
      }
      setHtmlPreview((prev) => ({ ...prev, body: html, fromTemplate: true }));
    } catch (err) {
      toast({
        title: 'Could not load the template',
        description: err?.response?.data?.message || err?.message || 'Request failed',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setTemplatePreviewLoading(false);
    }
  };

  const getIntervalLabel = (interval) => {
    switch (interval) {
      case 30000:
        return "30s";
      case 60000:
        return "1m";
      case 300000:
        return "5m";
      default:
        return "OFF";
    }
  };

  const handleViewPayload = (payload) => {
    const parsedPayload = JSON.parse(JSON.stringify(payload, (key, value) => {
      if (typeof value === "string" && value.startsWith("{") && value.endsWith("}")) {
        try {
          return JSON.parse(value);
        } catch {
          return value;
        }
      }
      return value;
    }));

    const formatted = JSON.stringify(parsedPayload, null, 2);
    setSelectedPayload(formatted);
    onPayloadOpen();

    setTimeout(() => Prism.highlightAll(), 0);
  };

  const downloadCSV = async () => {
    try {
      setIsDownloading(true);

      const params = new URLSearchParams();
      // params.append("customer_id", customer_id || "");

      if (appliedChannel?.value) params.append("channel", appliedChannel.value);
      if (appliedStatus?.value) params.append("status", appliedStatus.value);
      if (appliedStartDate) params.append("start_date", moment(appliedStartDate).format("YYYY-MM-DD"));
      if (appliedEndDate) params.append("end_date", moment(appliedEndDate).format("YYYY-MM-DD"));
      if (debouncedSearchValue.trim()) params.append("search", debouncedSearchValue.trim());

      const constructedUrl = `${process.env.REACT_APP_API_URL}/msg-log/export-data?${params.toString()}`;

      // Progress/failure now shows in the persistent top banner (survives a
      // reload) instead of a toast — see CsvExportProvider.
      await startExport({
        exportUrl: constructedUrl,
        label: "Delivery Logs export",
        filenameFallback: `messages_${moment().format("YYYY-MM-DD_HH-mm-ss")}.csv`,
      });
    } finally {
      setIsDownloading(false);
    }
  };

  // Reused for both the permissions-resolving spinner and the data-loading
  // spinner below — same shell, just a different reason for showing it.
  const loadingShell = (
    <>
      <Header header={header} />
      <BoxWrapper>
        <PageHeading icon={LuScrollText} title="Delivery Logs" subtitle="Track every message and its delivery status across channels" mb={4}>
          <HStack spacing={4}>
            <Box minW="300px">
              <Input
                placeholder="Search by Message ID, recipient"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                size={"sm"}
                isDisabled={true}
              />
            </Box>
            {exportPermission && (
              <Button
                size="sm"
                bg="var(--brand-primary)"
                isLoading={isDownloading}
                color="white"
                onClick={downloadCSV}
                isDisabled={true}
              >
                Export
              </Button>
            )}
            <HStack spacing={0} borderWidth="1px" borderRadius="md" overflow="hidden">
              <Button
                size="sm"
                bg="var(--brand-primary)"
                borderRightRadius={0}
                color="white"
                leftIcon={<RepeatIcon boxSize={3} />}
                onClick={() => loadList()}
                isDisabled={true}
              >
                Refresh
              </Button>
              <Menu>
                <MenuButton
                  as={Button}
                  size="sm"
                  variant="solid"
                  bg="var(--brand-primary)"
                  borderLeftRadius={0}
                  px={2}
                  color={"white"}
                  rightIcon={<ChevronDownIcon boxSize={3} />}
                  isDisabled={true}
                >
                  {autoRefreshInterval !== 0 && (
                    <Text ml={2} fontSize="xs" opacity={0.8}>
                      {getIntervalLabel(autoRefreshInterval)}
                    </Text>
                  )}
                </MenuButton>
                <MenuList minW="120px">
                  <MenuItem onClick={() => setAutoRefreshInterval(0)}>
                    OFF {autoRefreshInterval === 0 && <Icon as={CheckIcon} ml="auto" />}
                  </MenuItem>
                </MenuList>
              </Menu>
            </HStack>
            <Button
              onClick={toggleFilters}
              colorScheme="blue"
              variant={showFilters ? "solid" : "outline"}
              size="sm"
              className='updated-chakra-button'
              isDisabled={true}
            >
              {showFilters ? <MdOutlineFilterAltOff /> : <MdOutlineFilterAlt />}
            </Button>
          </HStack>
        </PageHeading>

        <Box overflowX="auto" border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          overflow="hidden">
          <Table>
            <Thead>
              <Tr>
                <Th w="200px">Message ID</Th>
                <Th w="160px">Recipient</Th>
                <Th w="400px">Message</Th>
                <Th w="180px">Channel</Th>
                <Th w="180px">Date & Time</Th>
                <Th w="190px">Status</Th>
              </Tr>
            </Thead>

            <Tbody>
              <Tr>
                <Td colSpan={6} textAlign="center" py={8}>
                  <Center h="400px">
                    <VStack spacing={3}>
                      <Spinner size="xl" color="blue.500" thickness="4px" />
                      <Text fontSize="sm" color="gray.600" fontWeight="medium">
                        Loading messages...
                      </Text>
                    </VStack>
                  </Center>
                </Td>
              </Tr>
            </Tbody>
          </Table>
        </Box>
      </BoxWrapper>
    </>
  );

  if (permissionsLoading) {
    return loadingShell;
  }

  if (!listPermission) {
    return (
      <>
        <Header header={header} />
        <BoxWrapper>
          <Box className='card-style'>
            <Center h="400px">
              <Box textAlign="center">
                <Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
                  No Access
                </Text>
                <Text fontSize="sm" color="gray.500">
                  You don't have permission to view this sections.
                </Text>
              </Box>
            </Center>
          </Box>
        </BoxWrapper>
      </>
    );
  }

  if (loading) {
    return loadingShell;
  }

  const getTypeId = (typeId) => {
    switch (typeId) {
      case 1:
        return "Authentication";
      case 2:
        return "Transactional";
      case 3:
        return "Marketing";
      case 4:
        return "Informational";
      case 5:
        return "Service";
      default:
        return "Unknown";
    }
  }
  return (
    <>
      <Header header={header} />

      <BoxWrapper>


        <PageHeading icon={LuScrollText} title="Delivery Logs" subtitle="Track every message and its delivery status across channels" mb={4}>
          {/* Search and Filter Toggle */}
          <HStack spacing={4}>
            <Box minW="300px">
              <Input
                placeholder="Search by Message ID, recipient"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                size={"sm"}
              />
            </Box>
            {exportPermission && (

              <Button
                size="sm"
                bg="var(--brand-primary)"
                isLoading={isDownloading}
                isDisabled={isExporting}
                color="white"
                // leftIcon={<RepeatIcon boxSize={3} />}
                onClick={downloadCSV}
              >
                Export

              </Button>
            )}
            <HStack spacing={0} borderWidth="1px" borderRadius="md" overflow="hidden">
              {/* Refresh Button */}
              <Button
                size="sm"
                bg="var(--brand-primary)"
                borderRightRadius={0}
                color="white"
                leftIcon={<RepeatIcon boxSize={3} />}
                onClick={() =>
                  loadList()
                }
              >
                Refresh

              </Button>
              {/* Auto Refresh Dropdown */}
              <Menu>
                <MenuButton
                  as={Button}
                  size="sm"
                  variant="solid"
                  bg="var(--brand-primary)"
                  borderLeftRadius={0}
                  px={2}
                  color={"white"}

                  rightIcon={<ChevronDownIcon boxSize={3} />}
                >{autoRefreshInterval !== 0 && (
                  <Text ml={2} fontSize="xs" opacity={0.8}>
                    {getIntervalLabel(autoRefreshInterval)}
                  </Text>
                )}</MenuButton>
                <MenuList minW="120px">
                  <MenuItem onClick={() => setAutoRefreshInterval(0)}>
                    OFF {autoRefreshInterval === 0 && <Icon as={CheckIcon} ml="auto" />}
                  </MenuItem>
                  <MenuItem onClick={() => setAutoRefreshInterval(30000)}>
                    Every 30s {autoRefreshInterval === 30000 && <Icon as={CheckIcon} ml="auto" />}
                  </MenuItem>
                  <MenuItem onClick={() => setAutoRefreshInterval(60000)}>
                    Every 1m {autoRefreshInterval === 60000 && <Icon as={CheckIcon} ml="auto" />}
                  </MenuItem>
                  <MenuItem onClick={() => setAutoRefreshInterval(300000)}>
                    Every 5m {autoRefreshInterval === 300000 && <Icon as={CheckIcon} ml="auto" />}
                  </MenuItem>
                </MenuList>
              </Menu>
            </HStack>
            <Button
              onClick={toggleFilters}
              colorScheme="blue"
              variant={showFilters ? "solid" : "outline"}
              size="sm"
              className='updated-chakra-button'
            >
              {showFilters ? <MdOutlineFilterAltOff /> : <MdOutlineFilterAlt />}
            </Button>
          </HStack>
        </PageHeading>

        {/* Toggleable Filters Card */}
        {showFilters && (
          <Box className='box-style-card' mb={4}>
            <Heading size="sm" mb={4} color="gray.600">Filter Options</Heading>

            {/* Date Range Filters */}
            <HStack spacing={4} mb={4} wrap="wrap">
              <Box minW="200px">
                <Text fontSize="sm" mb={2} color="gray.600">Start Date:</Text>
                <Input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </Box>

              <Box minW="200px">
                <Text fontSize="sm" mb={2} color="gray.600">End Date:</Text>
                <Input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </Box>
              <Box minW="200px">
                <Text fontSize="sm" mb={2} color="gray.600">Channel:</Text>
                <Select
                  options={channelOptions}
                  placeholder="All Channels"
                  value={selectedChannel}
                  onChange={setSelectedChannel}
                  isClearable
                />
              </Box>

              <Box minW="200px">
                <Text fontSize="sm" mb={2} color="gray.600">Status:</Text>
                <Select
                  options={statusOptions}
                  placeholder="All Status"
                  value={selectedStatus}
                  onChange={setSelectedStatus}
                  isClearable
                />
              </Box>
            </HStack>


            {/* Filter Action Buttons */}
            <HStack spacing={3} justifyContent="flex-end">
              <Button
                onClick={clearFilters}
                variant="outline"
                colorScheme="gray"
                size="sm"
              >
                Clear Filters
              </Button>

              <Button
                onClick={applyFilters}
                colorScheme="blue"
                size="sm"
                className='updated-chakra-button'
              >
                Apply Filters
              </Button>
            </HStack>


          </Box>
        )}

        {/* Active Filters Display */}
        {(appliedChannel || appliedStatus || appliedStartDate || appliedEndDate || debouncedSearchValue) && (
          <Box className='box-style-card' mb={4}>
            <Text fontSize="sm" fontWeight="semibold" color="blue.800" mb={2}>Active Filters:</Text>
            <HStack spacing={2} wrap="wrap">
              {appliedChannel && (
                <Box bg="blue.100" px={2} py={1} borderRadius="md" fontSize="xs">
                  Channel: {appliedChannel.label}
                </Box>
              )}
              {appliedStatus && (
                <Box bg="blue.100" px={2} py={1} borderRadius="md" fontSize="xs">
                  Status: {appliedStatus.label}
                </Box>
              )}
              {appliedStartDate && (
                <Box bg="blue.100" px={2} py={1} borderRadius="md" fontSize="xs">
                  From: {moment(appliedStartDate).format('DD/MM/YYYY')}
                </Box>
              )}
              {appliedEndDate && (
                <Box bg="blue.100" px={2} py={1} borderRadius="md" fontSize="xs">
                  To: {moment(appliedEndDate).format('DD/MM/YYYY')}
                </Box>
              )}
              {debouncedSearchValue && (
                <Box bg="blue.100" px={2} py={1} borderRadius="md" fontSize="xs">
                  Search: "{debouncedSearchValue}"
                </Box>
              )}
            </HStack>
          </Box>
        )}
        {(

          <Box overflowX="auto" border="1px solid"
            borderColor="gray.200"
            borderRadius="md"
            overflow="hidden">


            <Table >
              <Thead >
                <Tr>
                  <Th w="100px">Message ID</Th>
                  <Th w="160px">Recipient</Th>
                  <Th w="400px">Message</Th>
                  <Th w="180px">Channel</Th>


                  <Th w="180px">Date & Time</Th>
                  <Th w="190px">Status</Th>
                </Tr>
              </Thead>

              <Tbody>
                {
                  list.map((item) => (
                    <Tr key={item._id}>
                      <Td
                        whiteSpace="nowrap"
                        color="var(--brand-primary)"
                        cursor="pointer"
                        onClick={() => openModal(item)}
                        _hover={{ textDecoration: "underline" }}
                      >
                        <HStack spacing={1}>
                          <Text>{item._id.slice(0, 8)}...</Text>
                          <ExternalLinkIcon />
                        </HStack>
                      </Td>

                      <Td whiteSpace="nowrap"><RecipientInfo row={item} /></Td>

                      <Td
                        maxW="400px"
                        whiteSpace="nowrap"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        title={regexCheckHtml.test(messageBodyOf(item)) ? null : messageBodyOf(item)}
                      >
                        {regexCheckHtml.test(messageBodyOf(item)) ? (
                          // Opens a modal rather than a popover. The popover sized its
                          // iframe with `height: auto`, which an iframe resolves to its
                          // default ~150px regardless of content, so a full email arrived
                          // squeezed into a sliver inside a max-content popover.
                          <Text
                            color="var(--brand-primary)"
                            cursor="pointer"
                            isTruncated
                            textDecoration="underline"
                            onClick={() =>
                              setHtmlPreview({
                                to: item.to,
                                // Decode before rendering: this backend escapes stored
                                // strings (the same reason the Template Manager preview
                                // needs it). A no-op on already-raw HTML.
                                body: decodeHtmlEntities(messageBodyOf(item)),
                                templateId: item.message_template_id,
                              })
                            }
                          >
                            This message contains HTML. Click to preview.
                          </Text>
                        ) : (
                          messageBodyOf(item) || "—"
                        )}

                      </Td>
                      <Td>
                        {(() => {
                          const channel =
                            getChannel(item?.MsgChannel?.id) ||
                            getChannel(item?.MsgChannel?.name);
                          const IconComp = channel?.icon || FaMobileAlt;
                          const color = channel?.color || "gray";

                          return (
                            <>
                              <HStack spacing={2}>
                                <Icon as={IconComp} color={`${color}`} boxSize={4} />
                                <Text fontSize="sm" fontWeight="thin">
                                  {channel?.label || "N/A"}

                                </Text>
                              </HStack>
                              {/* SMS parts can legitimately be missing — show nothing rather
                                  than "Count: undefined". */}
                              {channel?.name === "SMS" && item?.message_count != null && (
                                <Text fontSize="xs" color="gray.500">Count: {item.message_count}</Text>
                              )}
                              {channel?.id === 4 && item?.message_count != null && (
                                <Text fontSize="xs" color="gray.500">Count: {item.message_count}</Text>
                              )}
                              {channel?.name === CHANNEL.WHATSAPP && item?.wa_billing_category && (
                                <Text fontSize="xs" color="gray.500" textTransform="capitalize">Category: {item.wa_billing_category}</Text>
                              )}
                            </>
                          );
                        })()}
                      </Td>







                      <Td whiteSpace="nowrap" verticalAlign="top">
                        <VStack align="flex-start" spacing={0}>
                          <Text color="#64748b" fontSize="xs">
                            Received:{" "}
                            {/* <strong style={{ color: "black" }}> */}
                            {item.receive_date ? moment
                              .utc(item.receive_date)
                              .tz(getUserTimeZone())
                              .format("DD MMM YY hh:mm:ss A") : "-"}
                            {/* </strong> */}
                          </Text>
                          <Text color="#64748b" fontSize="xs">
                            Sent:{" "}
                            {item.sent_date ? moment
                              .utc(item.sent_date)
                              .tz(getUserTimeZone())
                              .format("DD MMM YY hh:mm:ss A") : "-"}
                          </Text>
                        </VStack>
                      </Td>



                      <Td whiteSpace="nowrap">
                        <HStack spacing={2} align="center">
                          {/* Modern pill badge */}
                          {(() => {
                            const statusColor = safeStatusColor(item?.Status?.color);
                            return (
                              <HStack
                                spacing={1.5}
                                display="inline-flex"
                                alignItems="center"
                                px={2.5}
                                py={1}
                                borderRadius="full"
                                border="1px solid"
                                borderColor={`${statusColor}.200`}
                                bg={`${statusColor}.50`}
                              >
                                <Box
                                  w="6px"
                                  h="6px"
                                  borderRadius="full"
                                  bg={`${statusColor}.500`}
                                  flexShrink={0}
                                />
                                <Text
                                  fontSize="xs"
                                  color={`${statusColor}.700`}
                                  fontWeight="500"
                                  whiteSpace="nowrap"
                                >
                                  {item?.Status?.name || "Unknown"}
                                </Text>
                              </HStack>
                            );
                          })()}

                          {/* Error log icon — shown when status indicates failure (mirrors history view isFailed logic) */}
                          {(item?.Status?.name?.toLowerCase().includes("fail") || item?.Status?.name?.toLowerCase().includes("undeliverable")) && (
                            <Tooltip label="View error details" hasArrow>
                              {/* Plain info glyph — the status pill beside it already
                                  carries the failure colour, so a second red badge only
                                  competed with it. */}
                              <Box
                                as="span"
                                display="inline-flex"
                                alignItems="center"
                                cursor="pointer"
                                color="red.500"
                                _hover={{ color: "red.600" }}
                                onClick={() => {
                                  setSelectedErrorLog(item.error_log);
                                  onErrorLogOpen();
                                }}
                              >
                                <Icon as={LuInfo} boxSize={4} />
                              </Box>
                            </Tooltip>
                          )}
                        </HStack>
                      </Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>

            {/* Always shown — buttons just disable when there's no prev/next cursor. */}
            <Flex
              direction="column"
              justify="center"
              align="center"
              mt={6}
              mb={6}
              pt={6}
              borderTop="1px solid"
              borderColor="gray.100"
              gap={2}
            >
              <ButtonGroup size="sm" isAttached variant="outline">
                {[
                  { label: 'Previous', icon: <ChevronLeftIcon boxSize={5} />, onClick: goToPrevPage, enabled: paging.has_prev, side: 'left' },
                  { label: 'Next', icon: <ChevronRightIcon boxSize={5} />, onClick: goToNextPage, enabled: paging.has_next, side: 'right' },
                ].map(({ label, icon, onClick, enabled, side }) => (
                  <Button
                    key={label}
                    aria-label={`${label} page`}
                    leftIcon={side === 'left' ? icon : undefined}
                    rightIcon={side === 'right' ? icon : undefined}
                    onClick={onClick}
                    isDisabled={!enabled || loading}
                    borderColor="gray.200"
                    color="gray.700"
                    fontWeight="500"
                    px={4}
                    _hover={{ bg: 'var(--brand-tint)', color: 'var(--brand-primary)', borderColor: 'var(--brand-primary)' }}
                    _disabled={{ opacity: 0.45, cursor: 'not-allowed', _hover: { bg: 'transparent', color: 'gray.700', borderColor: 'gray.200' } }}
                  >
                    {label}
                  </Button>
                ))}
              </ButtonGroup>
              <Text fontSize="xs" color="gray.500">
                Showing <Text as="span" fontWeight="600" color="gray.700">{list.length}</Text> {list.length === 1 ? 'message' : 'messages'}
              </Text>
            </Flex>
          </Box>
        )}





        <Modal isOpen={isOpen} onClose={closeModal} size="xl" isCentered>
          <ModalOverlay />
          <ModalContent maxW="600px">
            <ModalHeader
              borderBottom="1px"
              borderColor="gray.200"
              pb={3}
              fontSize="lg"
              fontWeight="semibold"
            >
              <HStack spacing={2}>
                <Icon as={TimeIcon} color="blue.500" />
                <Text>Message Delivery Journey</Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton />

            <ModalBody py={4}>
              {selectedMessage ? (
                <VStack align="stretch" spacing={4}>
                  {/* Message ID */}
                  <Box bg="gray.50" borderRadius="md">
                    <Box bg="red.50" boxShadow="sm" borderRadius="lg" border={1} borderColor="red.200" borderStyle="solid" mb={2}>
                      <Text fontSize="xs" color="black" p={2}>
                        <Flex justifyContent={"space-between"} alignItems={"center"}>
                          <strong> Message Id: {selectedMessage.messageid || selectedMessage._id}</strong>
                          {(viewPaylaodPermission && selectedMessage.message_type_id !== 5) && (

                            <Button size={"xs"} bg={"rgb(var(--brand-primary-rgb) / 0.902)"} color={"white"} onClick={() => handleViewPayload(selectedMessage.customer_payload)}>View Payload</Button>
                          )}
                        </Flex>
                      </Text>
                    </Box>
                    <Text fontSize="sm" color="gray.600">
                      Complete delivery timeline showing channel-specific status
                      progression and auto-failover attempts.
                    </Text>
                  </Box>

                  {/* Info Grid */}
                  <Box
                    bg="blue.50"
                    border="1px"
                    borderColor="blue.200"
                    borderRadius="md"
                    p={3}
                  >
                    <Flex justify="space-between" mb={2}>
                      <Box flex="1">
                        <Text fontSize="xs" color="gray.600" mb={1}>
                          Recipient
                        </Text>
                        <RecipientInfo row={selectedMessage} fontSize="11px" />
                      </Box>
                      <Box flex="1">
                        <Text fontSize="xs" color="gray.600" mb={1}>
                          Message Type
                        </Text>
                        <Tag fontSize="xs" fontWeight="normal" border={"1px"} borderColor="gray.300"
                          color={"black"}
                          bg="white">
                          {getTypeId(selectedMessage.message_type_id)}

                        </Tag>
                      </Box>
                      <Box flex="1">
                        <Text fontSize="xs" color="gray.600" mb={1}>
                          Final Status
                        </Text>
                        <Badge
                          colorScheme={getStatusColor(selectedMessage?.Status?.name)}
                          px={2}
                          py={1}
                          borderRadius="md"
                        >
                          {selectedMessage?.Status?.name || "Unknown"}
                        </Badge>
                      </Box>


                    </Flex>
                    <Box flex="1" mb={4}>
                      <Text fontSize="xs" color="gray.600" mb={1}>
                        Subscriber ID
                      </Text>
                      <Text fontSize="sm" fontWeight="semibold">
                        {selectedMessage?.subscriber_id || '-'}
                      </Text>
                    </Box>
                    <Box>
                      {messageBodyOf(selectedMessage) && (
                        <>
                          <Text fontSize="xs" color="gray.600" mb={2} fontWeight="medium">
                            Message Content
                          </Text>
                          <Box bg="white" border={1} borderColor={"gray.100"} p={3} borderRadius="md">
                            {regexCheckHtml.test(messageBodyOf(selectedMessage)) ? (
                              // Same route as the Message column: EmailPreviewModal. Rendering
                              // the stored body inline here could not work — the log pipeline
                              // masks every digit to ****, so `border="****"` draws rules round
                              // every table, `padding:****px` is dropped and image URLs 404.
                              // The modal explains that and offers the source template, which
                              // is the only accurate render of this message.
                              <Flex align="center" justify="space-between" gap={3} flexWrap="wrap">
                                <Text fontSize="sm" color="gray.600">
                                  HTML email content · {messageBodyOf(selectedMessage).length.toLocaleString()} characters
                                </Text>
                                <Button
                                  size="sm"
                                  variant="outline"
                                  flexShrink={0}
                                  onClick={() =>
                                    setHtmlPreview({
                                      to: selectedMessage.to,
                                      body: decodeHtmlEntities(messageBodyOf(selectedMessage)),
                                      templateId: selectedMessage.message_template_id,
                                    })
                                  }
                                >
                                  Preview HTML
                                </Button>
                              </Flex>
                            ) : <Text fontSize="sm">{messageBodyOf(selectedMessage)}</Text>}

                          </Box>
                        </>
                      )}

                    </Box>

                  </Box>



                  <Box>
                    <HStack spacing={2} mb={3}>
                      <Icon as={TimeIcon} color="blue.500" boxSize={4} />
                      <Text fontSize="sm" fontWeight="semibold">
                        Delivery Timeline & Status Progression
                      </Text>
                    </HStack>

                    <VStack align="stretch" spacing={0} pl={2}>
                      {selectedMessage.history?.map((h, i) => {
                        const status = getStatusDetails(h.status_id);
                        const statusFallback = KNOWN_STATUS_FALLBACKS[h.status_id];
                        const displayStatusName =
                          status?.name || statusFallback?.name || `Status ${h.status_id}`;
                        const isSuccessStatus =
                          (status?.msg_status ?? statusFallback?.msg_status) === "1";

                        const { label: channelName, icon: ChannelIcon, color: channelColor } = getChannelInfo(h.channel_id);



                        const isFailed = status?.name?.toLowerCase().includes("fail") ||
                          status?.name?.toLowerCase().includes("undeliverable");


                        const currentIndex = selectedMessage.history.findIndex((item) => item === h);
                        const nextStatus = selectedMessage.history[currentIndex + 1];
                        const nextStatusDetails = nextStatus ? getStatusDetails(nextStatus.status_id) : null;

                        const isNextNotFailed =
                          nextStatusDetails &&
                          !nextStatusDetails?.name?.toLowerCase().includes("fail") &&
                          !nextStatusDetails?.name?.toLowerCase().includes("undeliverable");


                        const shouldTriggerFailover = isFailed && isNextNotFailed;


                        const getCooloredStatus = (status) => {
                          if (!status) return "white";
                          const name = status.name?.toLowerCase() || "";

                          if (name.includes("read") || name.includes("delivered")) return "#f0fdf4";
                          if (name.includes("sent")) return "var(--brand-tint)";
                          if (name.includes("clicked")) return "#f0fdf4";
                          if (name.includes("fail") || name.includes("undeliverable")) return "#fef2f2";
                          if (name.includes("invalid") || name.includes("undeliverable")) return "#fef2f2";
                          if (name.includes("accept")) return "white";
                          return "white";
                        }
                        const getCooloredBorderedStatus = (status) => {
                          if (!status) return "gray";
                          const name = status.name?.toLowerCase() || "";

                          if (name.includes("read") || name.includes("delivered")) return "#00c951";
                          if (name.includes("clicked") || name.includes("delivered")) return "#00c951";
                          if (name.includes("sent")) return "#2b7fff";
                          if (name.includes("fail") || name.includes("undeliverable")) return "#fb2c36";
                          if (name.includes("invalid") || name.includes("undeliverable")) return "#fb2c36";
                          if (name.includes("accept")) return "#6a7282";
                          return "gray";
                        }

                        return (
                          <Flex key={i}>
                            <Box
                              flex="1"
                              bg={getCooloredStatus(status)}
                              border="1px"
                              borderColor={getCooloredStatus(status)}
                              borderLeftWidth="4px"
                              borderLeftColor={getCooloredBorderedStatus(status)}
                              borderRadius="md"
                              my={3}
                              px={2}
                              py={5}
                            >
                              {/* ✅ Left icon + Right content */}
                              <Flex align="start" gap={3}>
                                {/* Left icon */}
                                {isSuccessStatus ? (
                                  <FiCheckCircle color="#00a63e" boxSize={4} />
                                ) : (
                                  <FiXCircle color="#e7000b" boxSize={4} />
                                )}

                                {/* Right content */}
                                <Box flex="1">
                                  <Flex justify="space-between" align="start" mb={1}>
                                    <HStack spacing={2}>
                                      {h.channel_id ? (
                                        <HStack spacing={1}>
                                          <Icon as={ChannelIcon} color={`${channelColor}`} boxSize={3.5} />
                                          <Text fontSize="xs" fontWeight="semibold">
                                            {channelName}
                                          </Text>
                                        </HStack>
                                      ) : (
                                        <Text fontSize="xs" fontWeight="semibold">
                                          {channelName}
                                        </Text>
                                      )}
                                      {status?.msg_status === "0" && <Tag bg={"red"} size={"sm"} color={"white"}>Failed</Tag>}
                                      <Tag
                                        size="sm"
                                        variant="outline"
                                        colorScheme={getStatusColor(displayStatusName)}
                                      >
                                        {displayStatusName}
                                      </Tag>
                                    </HStack>

                                    <Text fontSize="xs" color="gray.500">
                                      {new Date(h.time).toLocaleString("en-PK", {
                                        dateStyle: "short",
                                        timeStyle: "medium",
                                      })}
                                    </Text>
                                  </Flex>
                                  {(h.channel_id == 5 || h.channel_id == 6) && (
                                    <Text fontSize="xs" color="gray.600">Subscriber Id : {h.subscriber_id || '-'}</Text>
                                  )}
                                  {h.status_id === 110 && (
                                    <Text fontSize="xs" color="gray.600">Message Sent to device</Text>
                                  )}
                                  {h.channel_id == 2 && h.wa_billing_category && (
                                    <Text fontSize="xs" color="gray.600" textTransform="capitalize">Billing Category : {h.wa_billing_category}</Text>
                                  )}
                                  {isFailed ? (
                                    <Button
                                      size="xs"
                                      variant="outline"
                                      colorScheme="red"
                                      leftIcon={<WarningIcon />}
                                      mt={1}
                                      onClick={() => {
                                        // History entries rarely carry their own error_log — the
                                        // real payload almost always lives on the top-level message.
                                        setSelectedErrorLog(h.error_log || selectedMessage?.error_log);
                                        onErrorLogOpen();
                                      }}
                                    >
                                      Message Undeliverable — View Error Details
                                    </Button>
                                  ) : (
                                    <Text fontSize="xs" color="gray.600">
                                      {status?.description ||
                                        (status?.name === "Message Accepted"
                                          ? "Message Accepted - Request received and validated"
                                          : status?.name === "Message Sent"
                                            ? `Message Sent to ${channelName}`
                                            : status?.name === "Message Delivered"
                                              ? "Message Delivered"
                                              : status?.name === "Message Read"
                                                ? "Message Read"
                                                : "")}
                                    </Text>
                                  )}

                                  {shouldTriggerFailover && (
                                    <Text
                                      fontSize="xs"
                                      color="#ca3500"
                                      bg="#ffedd4"
                                      px={2}
                                      py={1}
                                      mt={2}
                                      borderRadius="md"
                                      fontWeight="medium"
                                    >
                                      → Triggering auto-failover to next channel
                                    </Text>
                                  )}
                                </Box>
                              </Flex>
                            </Box>
                          </Flex>
                        );
                      })}
                    </VStack>
                  </Box>
                </VStack>
              ) : (
                <Text>No details available.</Text>
              )}
            </ModalBody>

            <ModalFooter borderTop="1px" borderColor="gray.200">
              <Button onClick={closeModal} size={"sm"} bg="var(--brand-primary)"

                color="white">
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>



        <Modal isOpen={isPayloadOpen} onClose={onPayloadClose} size="4xl">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Payload Details</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              {selectedPayload ? (
                <Box
                  maxH="400px"
                  overflowY="auto"
                  // bg="gray.900"
                  color="green.200"
                  // p={4}
                  borderRadius="md"
                >
                  <pre
                    style={{
                      backgroundColor: "black",
                      textShadow: "none",
                      color: "white",
                      padding: "0px",
                      borderRadius: "8px",
                      fontFamily: "monospace",

                    }}
                  >
                    <span
                      style={{
                        padding: 15,
                        backgroundColor: "#2F2F2F",
                        fontSize: "14px",
                        display: "block",
                        marginBottom: "10px",

                      }}
                    >
                      json
                    </span>

                    <code
                      className="language-json"
                      style={{ padding: "0px 15px 15px", display: "block", whiteSpace: "pre-wrap" }}
                      dangerouslySetInnerHTML={{ __html: Prism.highlight(selectedPayload, Prism.languages.json, 'json') }}
                    />
                  </pre>

                </Box>
              ) : (
                <Text>No payload found.</Text>
              )}
            </ModalBody>
            <ModalFooter>
              <Button onClick={onPayloadClose} size={"sm"} bg="var(--brand-primary)"

                color="white">Close</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Error Log Modal */}
        <Modal isOpen={isErrorLogOpen} onClose={onErrorLogClose} size="xl" isCentered>
          <ModalOverlay />
          <ModalContent maxW="700px">
            <ModalHeader borderBottom="1px" borderColor="gray.100" pb={3}>
              <HStack spacing={2}>
                <Box
                  display="inline-flex" alignItems="center" justifyContent="center"
                  w="28px" h="28px" borderRadius="full"
                  bg="blue.50" border="1px solid" borderColor="blue.200"
                >
                  <WarningIcon color="blue.500" boxSize={3} />
                </Box>
                <Text fontSize="md" fontWeight="600" color="gray.800">Error Details</Text>
              </HStack>
            </ModalHeader>
            <ModalCloseButton top={3} />

            <ModalBody py={4}>
              {(() => {
                const raw = selectedErrorLog;
                if (!raw) return <Text color="gray.400" fontSize="sm">No error details available.</Text>;

                let parsed = raw;
                if (typeof raw === 'string') {
                  try { parsed = JSON.parse(raw); } catch { parsed = raw; }
                }

                const flattenObject = (obj, prefix = '') => {
                  if (typeof obj !== 'object' || obj === null) return { [prefix]: obj };
                  return Object.entries(obj).reduce((acc, [key, val]) => {
                    const newKey = prefix ? `${prefix}.${key}` : key;
                    if (val !== null && typeof val === 'object' && !Array.isArray(val)) {
                      Object.assign(acc, flattenObject(val, newKey));
                    } else {
                      acc[newKey] = val;
                    }
                    return acc;
                  }, {});
                };

                const renderValue = (val) => {
                  if (typeof val === 'boolean') {
                    return (
                      <Tag size="sm" borderRadius="full"
                        bg={val ? '#dcfce7' : '#fee2e2'}
                        color={val ? '#16a34a' : '#dc2626'}
                      >
                        {String(val)}
                      </Tag>
                    );
                  }
                  if (val === null || val === undefined) return <Text fontSize="sm" color="gray.400">—</Text>;
                  if (Array.isArray(val)) return <Text fontSize="sm" color="gray.700">{JSON.stringify(val)}</Text>;
                  return <Text fontSize="sm" color="gray.700">{String(val)}</Text>;
                };

                const flatData = Array.isArray(parsed)
                  // A single-item array (the overwhelmingly common case) doesn't need an
                  // "[0]." prefix on every key — it only exists to disambiguate multiple
                  // items, and otherwise just makes keys longer and harder to read.
                  ? (parsed.length === 1
                    ? flattenObject(parsed[0])
                    : parsed.reduce((acc, item, i) => Object.assign(acc, flattenObject(item, `[${i}]`)), {}))
                  : typeof parsed === 'object'
                    ? flattenObject(parsed)
                    : { value: parsed };

                // "value" as a raw key (e.g. a bounce webhook's `{ value: "Bounce" }`) reads
                // better to a customer as "Reason" — display-only relabel, key untouched.
                const displayKey = (key) => (key.toLowerCase() === 'value' ? 'Reason' : key);

                return (
                  <TableContainer border="1px" borderColor="gray.200" borderRadius="md">
                    <Table variant="simple" size="sm" tableLayout="fixed">
                      <Thead bg="gray.50">
                        <Tr>
                          <Th py={3} fontSize="xs" color="gray.700" fontWeight="700" w="180px">Key</Th>
                          <Th py={3} fontSize="xs" color="gray.700" fontWeight="700">Value</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {Object.entries(flatData).map(([key, val]) => (
                          <Tr key={key} _hover={{ bg: 'gray.50' }}>
                            <Td py={3} fontSize="sm" color="gray.600" borderColor="gray.100"
                              whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" title={key}>{displayKey(key)}</Td>
                            <Td py={3} borderColor="gray.100" wordBreak="break-word" whiteSpace="normal">{renderValue(val)}</Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                );
              })()}
            </ModalBody>

            <ModalFooter borderTop="1px" borderColor="gray.100">
              <Button onClick={onErrorLogClose} size="sm" bg="var(--brand-primary)" color="white" _hover={{ bg: 'var(--brand-primary-hover)' }}>
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* HTML message body, opened from the Message column. Rendered in the shared
            sandboxed-iframe modal so the email displays at full size and its CSS cannot
            leak into the app. */}
        <EmailPreviewModal
          isEmailPreviewOpen={!!htmlPreview}
          onEmailPreviewClose={() => setHtmlPreview(null)}
          title={htmlPreview?.fromTemplate ? "Message Preview — source template" : "Message Preview"}
          subjectLabel="Recipient:"
          subject={htmlPreview?.to || ''}
          body={htmlPreview?.body}
          onFallbackPreview={
            htmlPreview?.templateId && !htmlPreview?.fromTemplate
              ? () => loadTemplatePreview(htmlPreview.templateId)
              : undefined
          }
          fallbackLabel={`Preview template #${htmlPreview?.templateId} instead`}
          fallbackLoading={templatePreviewLoading}
          fallbackNote={
            htmlPreview?.fromTemplate
              ? 'Showing the source template, not the delivered message — variables are unsubstituted and later template edits will show through.'
              : undefined
          }
        />

      </BoxWrapper>
    </>
  )
}

export default MessageLogs;